/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export default class JarvisGlobalProd {
	dunamisToGPData(data) {
		let attempts = 0;
		const digitalData = window.digitalData;

		// if digitalData is undefined, we stop the execution of this script
		if (!digitalData) {
			if (!attempts) {
				attempts++;
				setTimeout(() => {
					this.dunamisToGPData(data);
				}, 500);
			}
			return;
		}

		const eventsArray = data.events;

		eventsArray.forEach((event) => {
			if (
				event.data['event.type'] === 'click' &&
				event.data['event.subcategory'] === 'launch' &&
				event.data['event.workflow'] === 'init'
			) {
				digitalData._set(
					'primaryEvent.eventInfo.eventName',
					[
						'chat',
						event.data['event.workflow'],
						event.data['event.subcategory'],
						event.data['event.subtype'],
						event.data['content.name'],
						event.data['event.type'],
					].join(':'),
				);

				digitalData._set(
					'primaryEvent.eventInfo.eventAction',
					[
						event.data['event.subcategory'],
						event.data['event.subtype'],
						event.data['content.name'],
						event.data['event.type'],
					].join(':'),
				);
			} else if (
				event.data['event.workflow'] === 'Chat' &&
				event.data['event.subcategory'] === 'Component' &&
				event.data['event.type'] === 'render' &&
				event.data['event.subtype'] === 'window'
			) {
				digitalData._set(
					'primaryEvent.eventInfo.eventName',
					[
						'chat',
						event.data['event.workflow'],
						event.data['event.subcategory'],
						event.data['event.subtype'],
						event.data['event.type'],
					].join(':'),
				);

				digitalData._set(
					'primaryEvent.eventInfo.eventAction',
					[event.data['event.subcategory'], event.data['event.subtype'], event.data['event.type']].join(':'),
				);
			} else if (event.data['event.error_code'] || event.data['event.error_type']) {
				digitalData._set(
					'primaryEvent.eventInfo.eventName',
					[
						'chat',
						event.data['event.workflow'],
						event.data['event.subtype'],
						event.data['event.type'],
						'error',
					].join(':'),
				);

				digitalData._set(
					'primaryEvent.eventInfo.eventAction',
					[
						event.data['event.subcategory'],
						event.data['event.subtype'],
						event.data['event.type'],
						'error',
					].join(':'),
				);
			} else if (
				event.data['event.type'] === 'render' &&
				event.data['event.subcategory'] === 'launch' &&
				event.data['event.workflow'] === 'init'
			) {
				digitalData._set(
					'primaryEvent.eventInfo.eventName',
					[
						'chat',
						event.data['event.workflow'],
						event.data['event.subcategory'],
						event.data['event.subtype'],
						event.data['content.name'],
						event.data['event.type'],
					].join(':'),
				);

				digitalData._set(
					'primaryEvent.eventInfo.eventAction',
					[event.data['event.subcategory'], event.data['content.name'], event.data['event.type']].join(':'),
				);
			} else {
				digitalData._set(
					'primaryEvent.eventInfo.eventName',
					[
						'chat',
						event.data['event.workflow'],
						event.data['content.name'],
						event.data['event.subtype'],
						event.data['event.type'],
					].join(':'),
				);

				digitalData._set(
					'primaryEvent.eventInfo.eventAction',
					[
						event.data['event.subcategory'],
						event.data['content.name'],
						event.data['event.subtype'],
						event.data['event.type'],
					].join(':'),
				);
			}

			this.populateChatInfo(event, digitalData);
			window._satellite.track('event', {
				digitalData: digitalData._snapshot(),
			});
		});
	}

	populateChatInfo(event, digitalData) {
		const map = {
			'event.context_guid': 'chat.chatInfo.chatConversationId',
			'event.session_guid': 'chat.chatInfo.chatConversationsessionid',
			'event.workflow': 'chat.chatInfo.chatWorkflow',
			'event.category': 'chat.chatInfo.chatCategory',
			'event.subcategory': 'chat.chatInfo.chatSubcategory',
			'event.type': 'chat.chatInfo.chatType',
			'event.subtype': 'chat.chatInfo.chatSubtype',
			'event.user_guid': 'chat.chatInfo.chatUserguid',
			'event.url': 'chat.chatInfo.chatUrl',
			'event.org_guid': 'chat.chatInfo.chatOrgguid',
			'event.referrer': 'chat.chatInfo.chatReferrer',
			'event.language': 'chat.chatInfo.chatLanguage',
			'event.pagename': 'chat.chatInfo.chatPagename',
			'event.visitor_guid': 'chat.chatInfo.chatVisitorguid',
			'event.error_code': 'chat.chatInfo.chatErrorCode',
			'event.error_type': 'chat.chatInfo.chatErrorType',
			'event.error_desc': 'chat.chatInfo.chatErrorDescription',

			'source.client_id': 'chat.chatInfo.chatClientId',
			'source.name': 'chat.chatInfo.chatSourceName',
			'source.platform': 'chat.chatInfo. chatPlatform',

			'content.name': 'chat.chatInfo.chatContentName',

			'env.com.name': 'chat.chatInfo.chatEnv',
		};

		for (const property in event.data) {
			if (!event.data.hasOwnProperty(property)) {
				continue;
			}

			// if we have data for that property and
			// if the property is one that we care about and it mapped
			if (event.data[property] && map[property]) {
				// set it on the data layer
				digitalData._set(map[property], event.data[property]);
			}
		}

		if (event.data['content.name'] === 'unread') {
			digitalData._set('chat.chatInfo.chatConversationUnread', 'true');
		} else if (event.data['content.name'] === 'read') {
			digitalData._set('chat.chatInfo.chatConversationUnread', 'false');
		}

		if (
			event.data['event.workflow'] === 'Chat' &&
			event.data['event.subcategory'] === 'Component' &&
			event.data['event.type'] === 'render' &&
			event.data['event.subtype'] === 'window'
		) {
			digitalData._set('chat.chatInfo.chatConversationOpen', 'true');
		}
	}
}
